import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from 'src/app/shared/services';

export const IsDeletedGuard: CanActivateFn = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
    ) => {

        const authService = inject( AuthService );
        const router      = inject( Router );
      
        if ( authService.currentUser()?.isDeleted ) {
          return true;
        }
      
        router.navigate(['auth/login']);
        return false;
}